import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  LinearProgress,
  Skeleton,
  Typography,
} from "@mui/material";

import { IoIosArrowRoundBack, IoIosArrowRoundForward } from "react-icons/io";
import { LuCalendarRange } from "react-icons/lu";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import EventCard from "./event-card";
import logo from "../../assets/logo/logo.svg";
import Footer from "../../Component/common/Footer";
import { getEventOverview } from "../../api";
import { useLocation } from "react-router-dom";

const DAYS = ["S", "M", "T", "W", "T", "F", "S"];

const LandingPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [slides, setSlides] = useState([]);
  const [selectedTime, setSelectedTime] = useState("12 PM");
  const [restaurantData, setRestaurantData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();
  const name = pathname.replace("/", "");

  const handleGetEventOverview = async () => {
    setIsLoading(true);
    await getEventOverview(name)
      .then((res) => {
        setRestaurantData(res.data?.result);
        console.log(res.data?.result);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const Events = restaurantData?.Events || [];
  const address = restaurantData?.RestaurantAddress || "";
  const restaurant_name = restaurantData?.RestaurantName || "";

  useEffect(() => {
    if (Events.length > 0) {
      const eventImages = Events.map((event) => event.ImageUrl).filter(
        (img) => img,
      );
      setSlides(eventImages.length > 0 ? eventImages : []);
    }
  }, [restaurantData]);

  console.log(currentSlide);

  useEffect(() => {
    handleGetEventOverview();
  }, [name]);

  const handleNext = () => {
    if (slides.length === 0) return;
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const handlePrev = () => {
    if (slides.length === 0) return;
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const handleMonthChange = (direction) => {
    setCurrentMonth((prev) => {
      const next = new Date(prev);
      next.setMonth(prev.getMonth() + direction);
      return next;
    });
  };

  const getCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const days = [];

    // Empty slots before first day
    for (let i = 0; i < firstDay.getDay(); i += 1) {
      days.push(null);
    }

    // Actual days of month
    for (let d = 1; d <= lastDay.getDate(); d += 1) {
      days.push(new Date(year, month, d));
    }

    return days;
  };

  const isSameDay = (a, b) =>
    a &&
    b &&
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const today = new Date();

  const isToday = (date) => isSameDay(date, today);

  const monthLabel = currentMonth.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  return (
    <Box
      sx={{ backgroundColor: "rgba(188, 23, 47, 0.05)", minHeight: "100vh" }}
    >
      <Box
        sx={{
          width: {
            xl: "30%",
            lg: "40%",
            md: "50%",
            sm: "65%",
            xs: "100%",
          },
          margin: "0 auto",
          backgroundColor: "#fff",
          minHeight: "100vh",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "grid",
            placeContent: "center",
            height: "60px",
            borderBottom: "5px solid #bc172f",
          }}
        >
          <img src={logo} alt="reisty_logo" />
        </Box>
        {/* Carousel container */}
        {isLoading || Events?.length === 0 ? (
          <>
            <Skeleton
              variant="rectangular"
              animation="wave"
              width="100%"
              height="65vh"
            ></Skeleton>
            <Box sx={{ mt: 3, px: 3 }}>
              <Skeleton
                variant="text"
                animation="wave"
                width="40%"
                height={25}
                sx={{ mb: 2, borderRadius: 0 }}
              />
              <Box
                sx={{
                  mt: 2,
                  mb: 4,
                  display: "flex",
                  columnGap: 2,
                  alignItems: "center",
                  overflowX: "auto",
                }}
                className="hide_scrollbar"
              >
                {Array.from(new Array(3)).map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="rectangular"
                    animation="wave"
                    width={300}
                    height={150}
                    sx={{ flexShrink: 0 }}
                  />
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                bgcolor: "#ffffff65",
                py: 2,
                display: "grid",
                placeItems: "center",
              }}
            >
              <Box>
                <p
                  style={{
                    textAlign: "center",
                    fontFamily: "optima",
                    textTransform: "capitalize",
                  }}
                >
                  {name}
                </p>
                <LinearProgress sx={{ width: 250, height: 2 }} />
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                position: "relative",
                height: "65vh",
              }}
            >
              {slides.map((slide, index) => (
                <Box
                  key={index}
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${slide})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    transition: "opacity 1s ease-in-out",
                    opacity: index === currentSlide ? 1 : 0,
                  }}
                />
              ))}

              {/* Bottom fade-out overlay to blend with the rest of the page */}
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  height: "120px",
                  background:
                    "linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #fff 90%)",
                  pointerEvents: "none",
                }}
              />

              {/* Carousel controls */}
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 16,
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  columnGap: 2,
                  px: 2,
                }}
              >
                <IconButton
                  variant="contained"
                  size="small"
                  onClick={handlePrev}
                  sx={{
                    textTransform: "none",
                    color: "#fff",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                  }}
                >
                  <IoIosArrowRoundBack style={{ fontSize: "20px" }} />
                </IconButton>
                <IconButton
                  variant="contained"
                  size="small"
                  onClick={handleNext}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                  }}
                >
                  <IoIosArrowRoundForward style={{ fontSize: "20px" }} />
                </IconButton>
              </Box>
            </Box>

            <Box sx={{ mt: 3, px: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontFamily: "optima", fontWeight: 500 }}>
                  {restaurant_name} Upcoming Events
                </Typography>
                <IconButton onClick={() => setCalendarOpen(true)}>
                  <LuCalendarRange
                    style={{ fontSize: "22px", color: "#333" }}
                  />
                </IconButton>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  mb: 4,
                  display: "flex",
                  columnGap: 2,
                  alignItems: "center",
                  overflowX: "auto",
                }}
                className="hide_scrollbar"
              >
                {Events.map((event, index) => (
                  <EventCard
                    key={index}
                    id={restaurantData?.RestaurantId}
                    bg={event?.ImageUrl}
                    day={formatDate(event.Date).split(" ")[0]}
                    month={formatDate(event.Date).split(" ")[1]}
                    titleLine1={event?.EventName}
                    ticket={event?.TotalTickets}
                    organizer={restaurant_name}
                    city={address.split("").length - 1}
                    venue={address}
                  />
                ))}
              </Box>

              <Footer />
            </Box>
          </>
        )}

        {/* Bottom calendar drawer */}
        <Drawer
          anchor="bottom"
          open={calendarOpen}
          onClose={() => setCalendarOpen(false)}
          PaperProps={{
            sx: {
              borderTopLeftRadius: "24px",
              borderTopRightRadius: "24px",
              maxHeight: "90vh",
            },
          }}
        >
          <Box
            sx={{
              px: 3,
              pt: 2,
              pb: 3,
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  width: 40,
                  height: 4,
                  borderRadius: 999,
                  bgcolor: "#E0E0E0",
                }}
              />
            </Box>

            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 18,
                textAlign: "center",
                fontFamily: "optima",
              }}
            >
              Event Calendar
            </Typography>

            {/* Calendar */}
            <Box
              sx={{
                borderRadius: 3,
                background: "rgba(188, 23, 47, 0.05)",
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <Button
                  size="small"
                  onClick={() => handleMonthChange(-1)}
                  sx={{ minWidth: 0, px: 1 }}
                >
                  <FaAngleLeft />
                </Button>
                <Typography sx={{ fontWeight: 600, fontFamily: "optima" }}>
                  {monthLabel}
                </Typography>
                <Button
                  size="small"
                  onClick={() => handleMonthChange(1)}
                  sx={{ minWidth: 0, px: 1 }}
                >
                  <FaAngleRight />
                </Button>
              </Box>

              <Grid container columns={7} spacing={1} sx={{ mb: 1 }}>
                {DAYS.map((d) => (
                  <Grid item xs={1} key={d}>
                    <Typography
                      sx={{
                        fontSize: 11,
                        textAlign: "center",
                        color: "#9E9E9E",
                      }}
                    >
                      {d}
                    </Typography>
                  </Grid>
                ))}
              </Grid>

              <Grid container columns={7} spacing={1}>
                {getCalendarDays().map((date, idx) => (
                  <Grid item xs={1} key={idx}>
                    <Box
                      onClick={() => date && setSelectedDate(date)}
                      sx={{
                        width: 36,
                        height: 36,
                        fontSize: "12px",
                        mx: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        cursor: date ? "pointer" : "default",
                        bgcolor: isSameDay(date, selectedDate)
                          ? "primary.main"
                          : "transparent",
                        color: isSameDay(date, selectedDate) ? "#fff" : "#333",
                        border:
                          !isSameDay(date, selectedDate) && isToday(date)
                            ? "1.5px solid #3f51b5"
                            : "none",
                        opacity: date ? 1 : 0,
                        "&:hover": date
                          ? {
                              bgcolor: isSameDay(date, selectedDate)
                                ? "primary.dark"
                                : "rgba(25, 118, 210, 0.08)",
                            }
                          : undefined,
                      }}
                    >
                      {date ? date.getDate() : ""}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Time selection */}
            {/* <Box>
              <Typography sx={{ fontWeight: 500, mb: 1, fontFamily:'optima' }}>Time</Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                {["10 AM", "12 PM", "2 PM", "4 PM"].map((time) => (
                  <Button
                    key={time}
                    size="small"
                    variant={selectedTime === time ? "contained" : "outlined"}
                    onClick={() => setSelectedTime(time)}
                    sx={{
                      borderRadius: 999,
                      textTransform: "none",
                      px: 2.5,
                      fontSize: 12,
                    }}
                  >
                    {time}
                  </Button>
                ))}
              </Box>
            </Box> */}

            <Button
              fullWidth
              variant="contained"
              sx={{
                mt: 1,
                borderRadius: 999,
                py: 1.6,
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={() => setCalendarOpen(false)}
            >
              Add to Calendar
            </Button>
          </Box>
        </Drawer>
      </Box>
    </Box>
  );
};

export default LandingPage;

const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
};
